module.exports = __webpack_public_path__ + "static/assets/9d0332a501d30dd71808b0cfde965b17.svg";